cafm.enums = {
    add: (enums) => {
        for (var enumName in enums) {
            if (enums.hasOwnProperty(enumName)) {
                cafm.enums[enumName] = enums[enumName];
            }
        }; 
    },
    getEnumKey: function (e, v) {
        /// <summary>Gets the key for an enum by its value</summary>
        /// <param name="e" type="Object">Enum Object</param>
        /// <param name="v" type="Integer">The value to search for</param>
        /// <returns type="String">The enum key</returns>

        for (var k in e) {
            if (e[k] == v) {
                return k;
            }
        }
    },
    isSingleEnumValue: function (value, enumValues) {
        /// <summary>Checks if an enum value is equal to one of the enum values specified</summary>
        /// <param name="value" type="Integer">Enum value</param>
        /// <param name="enumValues" type="Array">Enum values to check for a match</param>
        /// <returns type="Boolean">True if the value is equal to 1 one of the enum values, false otherwise</returns>

        var matchCount = 0;
        enumValues.forEach(function (enumValue) {

            if (value === enumValue) {

                matchCount++;
            }
        });

        return matchCount == 1;
    }
}